/* FoldifyCase Rewards: launcher, panel and the points lines elsewhere on the
 * page (header gift button, buy-box line, cart drawer row, rewards page
 * buttons). Config: #fc-rw-cfg (sections/fc-rewards.liquid). Backend: the app
 * proxy /apps/rewards → support-chat/lib/loyalty.ts.
 *
 * Visibility: cfg.mode "live" shows everything; "preview" only while
 * window.Shopify.theme.role is not "main" (a preview link of an unpublished
 * theme); otherwise every [data-fc-rw-reveal] element stays hidden and no
 * listener is attached.
 *
 * Public: window.fcRewards.open(view) / close(); any element with
 * [data-fc-rewards-open="home|redeem|refer|birthday|history"] opens the panel;
 * #rewards in the URL opens it; ?fcref=<code>[&fcn=<first name>] opens the
 * friend's referral view. */
(function () {
  'use strict';
  var root = document.getElementById('fc-rw');
  if (!root || root.__fcrw) return;
  root.__fcrw = true;
  var cfg;
  try { cfg = JSON.parse(document.getElementById('fc-rw-cfg').textContent); } catch (e) { return; }

  function themeRole() {
    try { return (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || ''; } catch (e) { return ''; }
  }
  /* Amounts and numbers printed by Liquid elsewhere (the rewards page): rewards
     are AUD amounts converted at checkout, so show them in the shopper's
     currency; runs whatever the mode, the page itself decides to exist. */
  (function paintStatic() {
    var l = cfg.locale || 'en-AU';
    try { new Intl.NumberFormat(l); } catch (e) { l = cfg.lang || 'en'; }
    var r = 1, c = cfg.currency || 'AUD';
    try { r = parseFloat(window.Shopify.currency.rate) || 1; c = window.Shopify.currency.active || c; } catch (e) {}
    document.querySelectorAll('[data-fc-rw-money]').forEach(function (el) {
      var v = Math.round(Number(el.getAttribute('data-fc-rw-money')) * r * 100) / 100;
      var whole = Math.abs(v - Math.round(v)) < 0.005;
      try { el.textContent = new Intl.NumberFormat(l, { style: 'currency', currency: c, currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v); } catch (e) {}
    });
    document.querySelectorAll('[data-fc-rw-num]').forEach(function (el) {
      try { el.textContent = Number(el.getAttribute('data-fc-rw-num')).toLocaleString(l); } catch (e) {}
    });
  })();

  var visible = cfg.mode === 'live' || (cfg.mode === 'preview' && themeRole() !== 'main' && themeRole() !== '');
  if (!visible) return;

  var T = cfg.t || {};
  var R = {
    perDollar: 5, join: 200, instagram: 100, facebook: 100, birthday: 200, anniversary: 100, review: 200, referral: 1000,
    redeemMin: 500, redeemStep: 100, redeemMax: 5000, pointsPerDollarOff: 100, expressCost: 1500, referralFriendOff: 10,
    referralMinOrder: 50, birthdayLeadDays: 30,
    instagramUrl: 'https://www.instagram.com/usfoldifycase/', facebookUrl: 'https://www.facebook.com/profile.php?id=61573493393220'
  };
  var S = {
    signedIn: !!cfg.signedIn,
    member: !!cfg.memberSince,
    firstName: cfg.firstName || '',
    points: Number(cfg.points) || 0,
    birthday: cfg.birthday ? String(cfg.birthday).slice(5) : null,
    actions: cfg.actions && typeof cfg.actions === 'object' ? cfg.actions : {},
    history: Array.isArray(cfg.history) ? cfg.history.slice(0, 20) : [],
    referral: null,
    loaded: false
  };
  var view = 'home';
  var last = null; // last code result
  var friend = null; // {ref, name}
  var busy = false;
  var error = '';

  var launch = root.querySelector('[data-fc-rw-launch]');
  var win = root.querySelector('.fc-rw-win');
  var body = root.querySelector('[data-fc-rw-body]');
  var opener = null;

  /* ── formatting ── */
  function loc() {
    var l = cfg.locale || 'en-AU';
    try { new Intl.NumberFormat(l); return l; } catch (e) { return cfg.lang || 'en'; }
  }
  function rate() {
    var r = 1;
    try { r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) {}
    return r > 0 ? r : 1;
  }
  function currency() {
    try { return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || cfg.currency || 'AUD'; } catch (e) { return cfg.currency || 'AUD'; }
  }
  /* A reward is a fixed AUD amount; Shopify converts it at checkout, so show it converted. */
  function money(aud) {
    var v = Math.round(aud * rate() * 100) / 100;
    var whole = Math.abs(v - Math.round(v)) < 0.005;
    try {
      return new Intl.NumberFormat(loc(), { style: 'currency', currency: currency(), currencyDisplay: 'narrowSymbol', minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: 2 }).format(v);
    } catch (e) { return currency() + ' ' + v.toFixed(whole ? 0 : 2); }
  }
  function num(n) {
    try { return Number(n).toLocaleString(loc()); } catch (e) { return String(n); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function fmt(key, vars) {
    var s = T[key] || '';
    return s.replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }
  /* points for a presentment price in cents: counted from the AUD price */
  function pointsFor(cents) {
    var aud = (Number(cents) || 0) / 100 / rate();
    return Math.max(0, Math.floor(Math.round(aud * 100) * R.perDollar / 100 + 1e-9));
  }
  var base = { one: money(1), join: num(R.join), per: num(R.pointsPerDollarOff), min: num(R.redeemMin) };

  /* ── icons ── */
  var P = {
    gift: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v8h14v-8M12 8v12M12 8c-1.6-3.2-5.2-3.6-5.2-1.2S9.8 8 12 8zm0 0c1.6-3.2 5.2-3.6 5.2-1.2S14.2 8 12 8z"/>',
    bag: '<path d="M5.5 8h13l-1 12.5h-11L5.5 8z"/><path d="M9 10V7a3 3 0 0 1 6 0v3"/>',
    join: '<circle cx="9" cy="8" r="3.5"/><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M19 8v6M16 11h6"/>',
    star: '<path d="M12 4l2.3 4.7 5.2.8-3.8 3.6.9 5.1L12 15.8l-4.6 2.4.9-5.1-3.8-3.6 5.2-.8z"/>',
    cam: '<rect x="4" y="4" width="16" height="16" rx="5"/><circle cx="12" cy="12" r="3.6"/><path d="M16.8 7.2h.01"/>',
    like: '<path d="M7.5 11v9H4v-9h3.5zm0 0 3.8-7c1.3 0 2.2 1 2.2 2.2V9h5a2 2 0 0 1 2 2.3l-1.1 6.4a2.7 2.7 0 0 1-2.6 2.3H7.5"/>',
    cake: '<path d="M4 20h16M5 20v-6a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v6M5 16c1.5 1 3 1 4.5 0s3-1 4.5 0 3 1 4.5 0M12 12V9M12 6.6c.9-.9.9-1.8 0-2.6-.9.8-.9 1.7 0 2.6z"/>',
    cal: '<rect x="4" y="5" width="16" height="15" rx="2"/><path d="M4 10h16M8 3v4M16 3v4M10 14.5l1.5 1.5 3-3"/>',
    users: '<circle cx="8.5" cy="8" r="3.2"/><circle cx="16.5" cy="9" r="2.6"/><path d="M2.8 19.5c0-3.1 2.6-5.6 5.7-5.6s5.7 2.5 5.7 5.6M15 14.2c3.2-.6 6.2 1.6 6.2 5.3"/>',
    tag: '<path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3-8.7 8.7-8.3-8.3z"/><circle cx="8" cy="8" r="1.4"/>',
    truck: '<path d="M3 6.5h11v9.5H3zM14 9.5h4l3 3.2V16h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    check: '<path d="M5 12.5l4.5 4.5L19 7.5"/>',
    copy: '<rect x="8.5" y="8.5" width="11.5" height="11.5" rx="2"/><path d="M15.5 8.5V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v7.5a2 2 0 0 0 2 2h2.5"/>',
    chev: '<path d="M9 6l6 6-6 6"/>',
    back: '<path d="M15 6l-6 6 6 6"/>',
    alert: '<circle cx="12" cy="12" r="8.5"/><path d="M12 7.5v5M12 16h.01"/>'
  };
  function ic(name) { return '<svg viewBox="0 0 24 24" aria-hidden="true">' + (P[name] || '') + '</svg>'; }

  /* ── pieces ── */
  function title(h, sub) {
    return '<div class="fc-rw-title"><h2>' + h + '</h2>' + (sub ? '<p>' + sub + '</p>' : '') + '</div>';
  }
  function row(icon, label, small, right) {
    return '<div class="fc-rw-row"><span class="fc-rw-ic">' + ic(icon) + '</span><span><b>' + label + '</b>' + (small ? '<small>' + small + '</small>' : '') + '</span>' + (right || '') + '</div>';
  }
  function pts(n) { return '<span class="fc-rw-pts">' + n + '</span>'; }
  function done() { return '<span class="fc-rw-done">' + ic('check') + esc(T.done) + '</span>'; }
  function errNote() {
    return error ? '<p class="fc-rw-note fc-rw-note--err" role="alert">' + ic('alert') + '<span>' + esc(error) + '</span></p>' : '';
  }
  function earnCard(compact) {
    var m = S.signedIn && S.member;
    var a = S.actions || {};
    var rows = [row('bag', esc(T.e_order), esc(fmt('e_order_s', base)), pts(num(R.perDollar) + ' ' + esc(T.pts)))];
    rows.push(row('star', esc(T.e_review), esc(T.e_review_s), pts(num(R.review))));
    if (m && !S.birthday) rows.push(row('cake', esc(T.e_bday_add), esc(fmt('e_birthday_s')) + ' · ' + num(R.birthday) + ' ' + esc(T.pts), '<button type="button" class="fc-rw-chipbtn" data-act="view:birthday">' + esc(T.add) + '</button>'));
    else rows.push(row('cake', esc(T.e_birthday), esc(T.e_birthday_s), m && S.birthday ? done() : pts(num(R.birthday))));
    if (!compact) {
      rows.push(row('cam', esc(T.e_insta), esc(T.e_once), m ? (a.instagram ? done() : '<button type="button" class="fc-rw-chipbtn" data-act="social:instagram">' + esc(T.follow) + ' · +' + num(R.instagram) + '</button>') : pts(num(R.instagram))));
      rows.push(row('like', esc(T.e_fb), esc(T.e_once), m ? (a.facebook ? done() : '<button type="button" class="fc-rw-chipbtn" data-act="social:facebook">' + esc(T.like) + ' · +' + num(R.facebook) + '</button>') : pts(num(R.facebook))));
      rows.push(row('cal', esc(T.e_anniv), esc(T.e_birthday_s), pts(num(R.anniversary))));
    }
    return '<div class="fc-rw-card"><p class="fc-rw-card__h">' + esc(T.earn_h) + '<a href="' + esc(cfg.page) + '">' + esc(T.see_all) + ic('chev') + '</a></p><div class="fc-rw-rows">' + rows.join('') + '</div></div>';
  }
  function redeemCard() {
    return '<div class="fc-rw-card"><p class="fc-rw-card__h">' + esc(T.redeem_h) + '</p><div class="fc-rw-rows">' +
      row('tag', esc(T.r_amount), esc(fmt('r_amount_s', base)), pts(money(R.redeemMin / R.pointsPerDollarOff) + '+')) +
      row('truck', esc(T.r_express), esc(T.r_express_s), pts(num(R.expressCost))) +
      '</div></div>';
  }
  function referUrl() {
    if (!S.referral) return '';
    var origin = location.origin;
    return origin + (cfg.root || '/') + '?fcref=' + encodeURIComponent(S.referral) + (S.firstName ? '&fcn=' + encodeURIComponent(S.firstName.split(' ')[0]) : '');
  }
  function referCard(full) {
    var s = esc(fmt('refer_s', { off: money(R.referralFriendOff), min: money(R.referralMinOrder), pts: num(R.referral) }));
    var link = '';
    if (full) {
      var url = referUrl();
      link = '<div class="fc-rw-ref"><code>' + (url ? esc(url.replace(/^https?:\/\//, '')) : '…') + '</code>' +
        (url ? '<button type="button" class="fc-rw-chipbtn" data-act="copy" data-copy="' + esc(url) + '">' + ic('copy') + '<span>' + esc(T.copy) + '</span></button>' : '') + '</div>';
    }
    return '<div class="fc-rw-card"><p class="fc-rw-card__h">' + esc(T.refer_h) + pts(num(R.referral) + ' ' + esc(T.pts)) + '</p><p>' + s + '</p>' + link + '</div>';
  }

  /* ── views ── */
  function vHome() {
    if (!S.signedIn) {
      return title(T.guest_title, esc(fmt('guest_sub', base))) + errNote() +
        '<a class="fc-rw-btn" href="' + esc(cfg.login) + '">' + esc(fmt('join_cta', base)) + '</a>' +
        '<p class="fc-rw-signin">' + esc(T.signin_q) + ' <a href="' + esc(cfg.login) + '">' + esc(T.signin) + '</a></p>' +
        earnCard(true) + redeemCard() + referCard(false);
    }
    if (!S.member) {
      var h = S.points > 0 ? fmt('waiting_title', { n: num(S.points) }) : T.guest_title;
      return title(h, esc(fmt('waiting_sub', base))) + errNote() +
        '<button type="button" class="fc-rw-btn" data-act="join"' + (busy ? ' aria-busy="true"' : '') + '>' + esc(T.join_btn) + '</button>' +
        '<p class="fc-rw-signin">' + esc(T.join_sub) + '</p>' + earnCard(true) + redeemCard();
    }
    var name = (S.firstName || '').split(' ')[0];
    var hi = name ? fmt('hi', { name: esc(name) }) : T.hi_noname;
    var maxUse = Math.min(R.redeemMax, Math.floor(Math.max(0, S.points) / R.redeemStep) * R.redeemStep);
    var bal = '<span class="fc-rw-eyebrow">' + esc(T.your_points) + '</span><span class="fc-rw-bal">' + num(Math.max(0, S.points)) + '<span>' + esc(T.pts) + '</span></span>';
    var inner;
    if (S.points >= R.redeemMin) {
      var start = Math.min(maxUse, Math.max(R.redeemMin, Math.floor(maxUse / 2 / R.redeemStep) * R.redeemStep));
      inner = '<p>' + esc(fmt('worth', { value: money(Math.floor(S.points / R.redeemStep) * R.redeemStep / R.pointsPerDollarOff) })) + '</p>' +
        '<div class="fc-rw-slide">' +
        '<div class="fc-rw-slide__top"><label for="fc-rw-range">' + esc(T.use) + '</label><b data-fc-rw-amt>' + money(start / R.pointsPerDollarOff) + '</b></div>' +
        '<input id="fc-rw-range" type="range" min="' + R.redeemMin + '" max="' + maxUse + '" step="' + R.redeemStep + '" value="' + start + '"' + (maxUse === R.redeemMin ? ' disabled' : '') + '>' +
        '<div class="fc-rw-slide__top"><span data-fc-rw-used>' + num(start) + ' ' + esc(T.points) + '</span><span>' + esc(fmt('min_note', base)) + '</span></div>' +
        '<button type="button" class="fc-rw-btn" data-act="redeem"' + (busy ? ' aria-busy="true"' : '') + '>' + esc(fmt('get_code', { value: money(start / R.pointsPerDollarOff) })) + '</button>' +
        (S.points >= R.expressCost ? '<button type="button" class="fc-rw-btn fc-rw-btn--glass" data-act="express">' + ic('truck') + esc(T.get_express) + ' · ' + num(R.expressCost) + '</button>' : '') +
        '</div>';
    } else {
      var need = R.redeemMin - Math.max(0, S.points);
      inner = '<p>' + esc(fmt('first_reward', { n: num(need) })) + '</p><div class="fc-rw-meter"><i style="width:' + Math.round(Math.max(0, S.points) / R.redeemMin * 100) + '%"></i></div>';
    }
    return title(hi) + errNote() + '<div class="fc-rw-card">' + bal + inner + '</div>' + earnCard(false) + referCard(true) +
      '<div class="fc-rw-card"><p class="fc-rw-card__h">' + esc(T.activity) + '<a href="#" data-act="view:history">' + esc(T.history) + ic('chev') + '</a></p></div>';
  }
  function backBtn() {
    return '<div><button type="button" class="fc-rw-back" data-act="view:home">' + ic('back') + esc(T.back) + '</button></div>';
  }
  function vCode() {
    var r = last || {};
    var amt = r.kind === 'express' ? T.express_title : '<em>' + esc(money(r.value || 0)) + '</em> ' + esc(T.off);
    var note = r.applied ? '<p class="fc-rw-note">' + ic('check') + '<span>' + esc(T.applied) + '</span></p>' : '<p class="fc-rw-note">' + ic('copy') + '<span>' + esc(T.applied_fail) + '</span></p>';
    var used = r.spent ? '<p class="fc-rw-small">' + esc(fmt('used', { spent: num(r.spent), left: num(Math.max(0, S.points)) })) + '</p>' : '';
    return backBtn() + '<div class="fc-rw-card fc-rw-codebox"><span class="fc-rw-mark">' + ic('check') + '</span><span class="fc-rw-eyebrow">' + esc(T.ready) + '</span>' +
      '<p class="fc-rw-amt">' + amt + '</p>' +
      '<div class="fc-rw-code"><span>' + esc(r.code || '') + '</span><button type="button" data-act="copy" data-copy="' + esc(r.code || '') + '" aria-label="' + esc(T.copy) + '">' + ic('copy') + '</button></div>' +
      note + '<button type="button" class="fc-rw-btn" data-act="gocart">' + esc(T.go_cart) + '</button>' + used + '</div>';
  }
  function hLabel(h) {
    var key = 'h_' + h.r;
    return esc(T[key] ? fmt(key, { l: h.l || '' }) : (h.l || h.r));
  }
  function hDate(t) {
    try { return new Intl.DateTimeFormat(loc(), { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(t)); } catch (e) { return String(t).slice(0, 10); }
  }
  function vHistory() {
    var list = S.history.length ? S.history.map(function (h) {
      return '<div class="fc-rw-row"><span><b>' + hLabel(h) + '</b><small>' + esc(hDate(h.t)) + '</small></span><span class="fc-rw-pts' + (h.p < 0 ? ' fc-rw-pts--neg' : '') + '">' + (h.p > 0 ? '+' : '') + num(h.p) + '</span></div>';
    }).join('') : '<p>' + esc(T.empty_history) + '</p>';
    return backBtn() + title(esc(T.activity)) + '<div class="fc-rw-card fc-rw-hist"><div class="fc-rw-rows">' + list + '</div></div>';
  }
  function vBirthday() {
    var months = '';
    for (var m = 1; m <= 12; m++) {
      var name = String(m);
      try { name = new Intl.DateTimeFormat(loc(), { month: 'long' }).format(new Date(Date.UTC(2000, m - 1, 15))); } catch (e) {}
      months += '<option value="' + m + '">' + esc(name) + '</option>';
    }
    var days = '';
    for (var d = 1; d <= 31; d++) days += '<option value="' + d + '">' + d + '</option>';
    return backBtn() + title(T.bday_title, esc(fmt('bday_note', { pts: num(R.birthday), days: num(R.birthdayLeadDays) }))) + errNote() +
      '<div class="fc-rw-card"><div class="fc-rw-pair">' +
      '<label class="fc-rw-field" for="fc-rw-bm">' + esc(T.month) + '<select id="fc-rw-bm">' + months + '</select></label>' +
      '<label class="fc-rw-field" for="fc-rw-bd">' + esc(T.day) + '<select id="fc-rw-bd">' + days + '</select></label>' +
      '</div><button type="button" class="fc-rw-btn" data-act="birthday"' + (busy ? ' aria-busy="true"' : '') + '>' + esc(T.save) + '</button></div>';
  }
  function vFriend() {
    var vars = { off: esc(money(R.referralFriendOff)), min: esc(money(R.referralMinOrder)), name: esc(friend && friend.name || '') };
    var h = friend && friend.name ? fmt('friend_title', vars) : fmt('friend_title_noname', vars);
    return title(h, esc(fmt('friend_sub', { min: money(R.referralMinOrder) }))) + errNote() +
      '<div class="fc-rw-card"><label class="fc-rw-field" for="fc-rw-femail">' + esc(T.email) + '<input id="fc-rw-femail" type="email" autocomplete="email" inputmode="email" required></label>' +
      '<button type="button" class="fc-rw-btn" data-act="refer"' + (busy ? ' aria-busy="true"' : '') + '>' + esc(fmt('get_friend_code', { off: money(R.referralFriendOff) })) + '</button></div>' + redeemCard();
  }
  function render() {
    var html;
    if (view === 'code') html = vCode();
    else if (view === 'history') html = vHistory();
    else if (view === 'birthday' && S.member) html = vBirthday();
    else if (view === 'friend') html = vFriend();
    else { view = 'home'; html = vHome(); }
    body.innerHTML = html;
    var range = body.querySelector('#fc-rw-range');
    if (range) range.addEventListener('input', paintRange);
  }
  function paintRange() {
    var range = body.querySelector('#fc-rw-range');
    if (!range) return;
    var p = Number(range.value);
    var v = money(p / R.pointsPerDollarOff);
    var amt = body.querySelector('[data-fc-rw-amt]');
    var used = body.querySelector('[data-fc-rw-used]');
    var btn = body.querySelector('[data-act="redeem"]');
    if (amt) amt.textContent = v;
    if (used) used.textContent = num(p) + ' ' + (T.points || '');
    if (btn) btn.textContent = fmt('get_code', { value: v });
  }

  /* ── backend ── */
  var ERR = {
    not_enough_points: 'err_not_enough', below_minimum: 'err_not_enough', sign_in_required: 'err_signin', self_referral: 'err_self',
    not_first_order: 'err_first', invalid_email: 'err_email', not_configured: 'err_setup', bad_signature: 'err_setup',
    rate_limited: 'err_busy', not_member: 'err_member', already_set: 'err_already'
  };
  function api(op, payload) {
    var opts = { method: payload ? 'POST' : 'GET', credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (payload) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(payload); }
    return fetch(cfg.proxy + '?op=' + encodeURIComponent(op), opts).then(function (r) {
      var ct = r.headers.get('content-type') || '';
      if (ct.indexOf('json') === -1) throw { error: r.status === 404 ? 'not_configured' : 'http_' + r.status };
      return r.json().then(function (j) { if (!r.ok) throw j || {}; return j; });
    });
  }
  function errText(e) { return T[ERR[e && e.error] || 'err_generic'] || ''; }
  function take(j) {
    if (!j || typeof j !== 'object') return;
    if (j.rules) for (var k in j.rules) if (Object.prototype.hasOwnProperty.call(j.rules, k)) R[k] = j.rules[k];
    if (typeof j.points === 'number') {
      S.points = j.points;
      S.member = !!j.member;
      if (j.firstName) S.firstName = j.firstName;
      S.birthday = j.birthday || null;
      S.actions = j.actions || S.actions;
      if (Array.isArray(j.history)) S.history = j.history;
      if (j.referral) S.referral = j.referral;
      S.loaded = true;
    }
    base = { one: money(1), join: num(R.join), per: num(R.pointsPerDollarOff), min: num(R.redeemMin) };
    paintOutside();
  }
  function refresh() {
    if (!S.signedIn) return;
    api('me').then(function (j) { take(j); if (win.dataset.open === 'true' && view === 'home') render(); }).catch(function () {});
  }
  function run(op, payload, then) {
    if (busy) return;
    busy = true;
    error = '';
    render();
    api(op, payload).then(function (j) {
      busy = false;
      take(j);
      then(j);
    }).catch(function (e) {
      busy = false;
      error = errText(e);
      render();
    });
  }

  /* ── cart ── */
  function cartRoot() {
    try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || cfg.root || '/'; } catch (e) { return cfg.root || '/'; }
  }
  function applyCode(code) {
    var C = String(code || '').toUpperCase();
    try { if (window.__fcdRememberManualCode) window.__fcdRememberManualCode(C); } catch (e) {}
    var r = cartRoot();
    return fetch(r + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = (cart && cart.discount_codes || []).map(function (d) { return d.code; }).filter(function (c) { return c && String(c).toUpperCase() !== C; });
        codes.push(C);
        var fd = new FormData();
        fd.append('discount', codes.join(','));
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        return fetch(r + 'cart/update.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (updated) {
        try { if (updated && updated.sections && window.FCDrawer && typeof window.FCDrawer.renderSections === 'function') window.FCDrawer.renderSections(updated.sections, false); } catch (e) {}
        return !!(updated && (updated.discount_codes || []).some(function (d) { return String(d.code).toUpperCase() === C; }));
      })
      .catch(function () { return false; });
  }
  function showCode(j, kind) {
    last = { code: j.code, kind: kind, value: j.value, spent: j.spent, applied: false };
    view = 'code';
    render();
    applyCode(j.code).then(function (ok) { last.applied = ok; if (view === 'code') render(); });
  }
  function goCart() {
    close();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    location.href = cfg.cart || '/cart';
  }

  /* ── open / close ── */
  function focusFirst() {
    var el = win.querySelector('button, a[href], input, select');
    if (el) try { el.focus({ preventScroll: true }); } catch (e) {}
  }
  function open(v, from) {
    opener = from || document.activeElement;
    // Opened from the cart drawer's "Use $X off": the drawer would sit on top.
    if (document.body.classList.contains('fcd-cart-open')) {
      var cd = document.querySelector('cart-drawer');
      try { if (cd && typeof cd.close === 'function') cd.close(); } catch (e) {}
    }
    if (v) view = v;
    error = '';
    render();
    win.hidden = false;
    requestAnimationFrame(function () { win.dataset.open = 'true'; });
    launch.setAttribute('aria-expanded', 'true');
    document.body.classList.add('fc-rw-active');
    setTimeout(focusFirst, 60);
    if (S.signedIn && (!S.loaded || (S.member && !S.referral))) refresh();
  }
  function close() {
    if (win.dataset.open !== 'true') return;
    win.dataset.open = 'false';
    launch.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('fc-rw-active');
    setTimeout(function () { if (win.dataset.open !== 'true') win.hidden = true; }, 260);
    if (opener && opener.focus) try { opener.focus({ preventScroll: true }); } catch (e) {}
  }

  /* ── events ── */
  launch.addEventListener('click', function () { if (win.dataset.open === 'true') close(); else open('home', launch); });
  root.querySelector('[data-fc-rw-close]').addEventListener('click', close);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && win.dataset.open === 'true') close(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-fc-rewards-open]') : null;
    if (t) {
      e.preventDefault();
      var v = t.getAttribute('data-fc-rewards-open') || 'home';
      open(v === 'redeem' || v === 'refer' ? 'home' : v, t);
      return;
    }
    // composedPath: a click inside the panel re-renders it, so the target can be
    // detached by now; the path still says where the click happened.
    var inside = e.composedPath ? e.composedPath().indexOf(root) !== -1 : root.contains(e.target);
    if (win.dataset.open === 'true' && window.matchMedia('(min-width: 750px)').matches && !inside) close();
  });
  body.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-act]') : null;
    if (!el) return;
    var act = el.getAttribute('data-act');
    if (act.indexOf('view:') === 0) { e.preventDefault(); error = ''; view = act.slice(5); render(); focusFirst(); return; }
    if (act === 'join') return run('join', {}, function () { view = 'home'; render(); });
    if (act === 'redeem') {
      var range = body.querySelector('#fc-rw-range');
      var p = range ? Number(range.value) : R.redeemMin;
      return run('redeem', { kind: 'amount', points: p }, function (j) { showCode(j, 'amount'); });
    }
    if (act === 'express') return run('redeem', { kind: 'express' }, function (j) { showCode(j, 'express'); });
    if (act.indexOf('social:') === 0) {
      var type = act.slice(7);
      try { window.open(type === 'instagram' ? R.instagramUrl : R.facebookUrl, '_blank', 'noopener'); } catch (err) {}
      return run('action', { type: type }, function () { render(); });
    }
    if (act === 'birthday') {
      var m = Number((body.querySelector('#fc-rw-bm') || {}).value);
      var d = Number((body.querySelector('#fc-rw-bd') || {}).value);
      return run('birthday', { month: m, day: d }, function () { view = 'home'; render(); });
    }
    if (act === 'refer') {
      var input = body.querySelector('#fc-rw-femail');
      var email = input ? String(input.value || '').trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { error = T.err_email || ''; render(); return; }
      return run('refer', { ref: friend && friend.ref, email: email }, function (j) { showCode({ code: j.code, value: j.value }, 'amount'); });
    }
    if (act === 'copy') {
      var text = el.getAttribute('data-copy') || '';
      var label = el.querySelector('span');
      var ok = function () { if (label) { var o = label.textContent; label.textContent = T.copied || ''; setTimeout(function () { label.textContent = o; }, 1400); } };
      try { navigator.clipboard.writeText(text).then(ok, ok); } catch (err) { ok(); }
      return;
    }
    if (act === 'gocart') goCart();
  });

  /* ── outside the panel: launcher label, header badge, buy-box line, cart row ── */
  function paintLauncher() {
    var label = root.querySelector('[data-fc-rw-launch-label]');
    if (S.signedIn && S.member) label.innerHTML = esc(num(Math.max(0, S.points))) + ' <small>' + esc(T.pts) + '</small>';
    else label.textContent = T.launch || '';
    launch.setAttribute('aria-label', T.open || '');
    root.querySelector('#fc-rw-title').textContent = T.brand || '';
    root.querySelector('[data-fc-rw-close-label]').textContent = T.close || '';
  }
  function compact(n) { return n >= 10000 ? Math.floor(n / 1000) + 'k' : num(n); }
  function paintHeader() {
    document.querySelectorAll('.fc-hd-rw[data-fc-rw-reveal]').forEach(function (b) {
      b.hidden = false;
      b.setAttribute('aria-label', T.open || '');
      var n = b.querySelector('.fc-hd-rw__n');
      if (n) {
        var show = S.signedIn && S.member && S.points > 0;
        n.hidden = !show;
        n.textContent = show ? compact(S.points) : '';
      }
    });
  }
  function paintEarn(cents) {
    document.querySelectorAll('[data-fc-rw-earn]').forEach(function (el) {
      if (cents != null) el.setAttribute('data-price', cents);
      var n = pointsFor(el.getAttribute('data-price'));
      if (!n) { el.hidden = true; return; }
      el.innerHTML = ic('gift') + '<span>' + fmt('earn_line', { n: esc(num(n)) }) + '</span><span class="fc-rw-earn__how">' + esc(T.how) + '</span>';
      el.hidden = false;
    });
  }
  function paintCart() {
    document.querySelectorAll('[data-fc-rw-cart]').forEach(function (el) {
      var total = Number(el.getAttribute('data-total')) || 0;
      if (!total) { el.hidden = true; return; }
      var earn = num(pointsFor(total));
      var b, s, btn;
      if (!S.signedIn) {
        b = fmt('cart_earn', { n: earn });
        s = '';
        btn = '<button type="button" data-fc-rw-signin>' + esc(T.signin) + '</button>';
      } else if (!S.member) {
        b = fmt('cart_earn', { n: earn });
        s = S.points > 0 ? fmt('cart_have', { n: num(S.points) }) : '';
        btn = '<button type="button" data-fc-rewards-open="home">' + esc(T.cart_join) + '</button>';
      } else if (S.points >= R.redeemMin) {
        var totalAud = total / 100 / rate();
        var cap = Math.min(R.redeemMax, Math.floor(S.points / R.redeemStep) * R.redeemStep, Math.floor(totalAud * R.pointsPerDollarOff / R.redeemStep) * R.redeemStep);
        b = fmt('cart_have', { n: num(S.points) });
        s = fmt('cart_earn_more', { n: earn });
        btn = cap >= R.redeemMin ? '<button type="button" data-fc-rewards-open="home">' + esc(fmt('cart_use', { value: money(cap / R.pointsPerDollarOff) })) + '</button>' : '';
      } else {
        b = fmt('cart_earn', { n: earn });
        s = fmt('cart_have', { n: num(Math.max(0, S.points)) });
        btn = '';
      }
      el.innerHTML = '<span class="fc-rw-mark">' + ic('gift') + '</span><span><b>' + esc(b) + '</b>' + (s ? '<small>' + esc(s) + '</small>' : '') + '</span>' + (btn || '<span></span>');
      var si = el.querySelector('[data-fc-rw-signin]');
      if (si) si.addEventListener('click', function () { location.href = cfg.login; });
      el.hidden = false;
    });
  }
  function paintOutside() { paintLauncher(); paintHeader(); paintEarn(); paintCart(); }

  root.hidden = false;
  paintOutside();
  document.querySelectorAll('[data-fc-rw-reveal]:not(.fc-hd-rw):not([data-fc-rw-earn]):not([data-fc-rw-cart])').forEach(function (el) { el.hidden = false; });
  document.addEventListener('fc:variant:change', function (e) {
    if (e && e.detail && e.detail.price != null) paintEarn(e.detail.price);
  });
  document.addEventListener('cart:updated', function () { setTimeout(paintCart, 60); });
  var drawer = document.querySelector('cart-drawer');
  if (drawer && window.MutationObserver) {
    var t = null;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () {
      var stale = document.querySelector('[data-fc-rw-cart]:empty');
      if (stale) paintCart();
    }, 40); }).observe(drawer, { childList: true, subtree: true });
  }

  /* referral landing and #rewards */
  try {
    var q = new URLSearchParams(location.search);
    var ref = q.get('fcref');
    if (ref && /^[0-9A-Za-z]{4,14}-[0-9A-Za-z]{2}$/.test(ref)) {
      var nm = (q.get('fcn') || '').replace(/[^\p{L}' -]/gu, '').slice(0, 20);
      friend = { ref: ref.toUpperCase(), name: nm };
      if (!(S.signedIn && S.member && S.referral === friend.ref)) setTimeout(function () { open('friend', launch); }, 400);
    } else if (location.hash === '#rewards') {
      setTimeout(function () { open('home', launch); }, 300);
    }
  } catch (e) {}

  window.fcRewards = { open: function (v) { open(v || 'home'); }, close: close, state: S };
})();
